import { HStack, Text, useColorModeValue, VStack } from "@chakra-ui/react";
import KellyansCards from "./KellyansCards";

export default function KellyansSide({ gameState }) {
  const textColor = useColorModeValue("#4b635e", "#E9A6A6");

  // get info from gameState
  const { kellyanDeck, kellyanEarnedCards, kellyanDownCards } = gameState;

  return (
    // Kellyan's cards display
    <VStack minW="175px" maxW="175px" h="325px" justify="space-between">
      {/* Kellyan Active Deck */}
      <HStack w="100%" spacing="10px" justify="start" align="start">
        <VStack spacing="0px" minW="60px">
          <Text
            textAlign="center"
            fontSize="lg"
            opacity="80%"
            fontFamily="Lilita One, sans-serif"
            minW="40px"
            lineHeight="18px"
          >
            {kellyanDeck.length +
              kellyanDownCards.length +
              kellyanEarnedCards.length}
          </Text>
          <Text
            textAlign="center"
            fontSize="12px"
            lineHeight="15px"
            opacity="80%"
            fontFamily="Lilita One, sans-serif"
            minW="40px"
          >
            Total
          </Text>
        </VStack>
        <Text
          fontSize="lg"
          color={textColor}
          fontFamily="Lilita One, sans-serif"
          lineHeight="18px"
        >
          Kellyan
        </Text>
      </HStack>

      {/* Kellyan's Cards */}
      <KellyansCards gameState={gameState} />

      {/* Kellyan Earned Deck */}
      <HStack w="100%" spacing="0px">
        <VStack spacing="0px">
          <Text
            textAlign="center"
            fontSize="lg"
            opacity="80%"
            fontFamily="Lilita One, sans-serif"
            minW="40px"
            lineHeight="18px"
          >
            {kellyanDeck.length + kellyanDownCards.length}
          </Text>
          <Text
            textAlign="center"
            fontSize="12px"
            lineHeight="15px"
            opacity="80%"
            fontFamily="Lilita One, sans-serif"
            minW="40px"
          >
            Deck
          </Text>
        </VStack>
        <VStack spacing="0px">
          <Text
            textAlign="center"
            fontSize="lg"
            opacity="80%"
            fontFamily="Lilita One, sans-serif"
            minW="40px"
            lineHeight="18px"
          >
            {kellyanEarnedCards.length}
          </Text>
          <Text
            textAlign="center"
            fontSize="12px"
            lineHeight="15px"
            opacity="80%"
            fontFamily="Lilita One, sans-serif"
            minW="40px"
          >
            Earned
          </Text>
        </VStack>
      </HStack>
    </VStack>
  );
}
